import { useEffect, useState } from "react";
import { ShieldCheck } from "lucide-react";
import { http, notify } from "../api";
import { Loading } from "./common";

function formatValue(v) {
  if (v === null || v === undefined || v === "") return "—";
  if (typeof v === "boolean") return v ? "Yes" : "No";
  if (typeof v === "object") return JSON.stringify(v);
  return String(v);
}

export default function Audit() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    http.get("/audit")
      .then((r) => setItems(r.data))
      .catch((err) => notify.error(err, "Could not load audit log"))
      .finally(() => setLoading(false));
  }, []);

  return (
    <>
      <div className="page-intro">
        <div>
          <p className="eyebrow">GOVERNANCE / TRACEABILITY</p>
          <h1>Audit log</h1>
          <p className="muted">Every change with who, what, old value, new value, when and reason.</p>
        </div>
        <span className="scope-chip"><ShieldCheck size={14} /> Access monitored</span>
      </div>

      {loading ? (
        <Loading>Reviewing entries…</Loading>
      ) : (
        <div data-testid="audit-log-table" className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>Event</th>
                <th>Field</th>
                <th>Old → New</th>
                <th>Reason</th>
                <th>Actor</th>
                <th>Record</th>
                <th>Time</th>
              </tr>
            </thead>
            <tbody>
              {items.map((x, i) => (
                <tr data-testid={`audit-row-${i}`} key={`${x.lead_id}-${x.created_at}-${i}-${x.field || ""}`}>
                  <td><strong>{x.action}</strong></td>
                  <td>{x.field_label || (x.field ? x.field : "—")}</td>
                  <td>
                    {x.field ? (
                      <>
                        <span className="muted">{formatValue(x.old_value)}</span>
                        {" → "}
                        <strong>{formatValue(x.new_value)}</strong>
                      </>
                    ) : "—"}
                  </td>
                  <td className="muted small">{x.reason || "—"}</td>
                  <td>{x.user}{x.role ? <><br /><small className="muted">{x.role}</small></> : null}</td>
                  <td className="mono">{x.lead_id || "—"}</td>
                  <td className="muted">{x.created_at?.slice(0, 16).replace("T", " · ")}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {!items.length && <div className="empty">No audit entries recorded yet.</div>}
        </div>
      )}
    </>
  );
}
